import React from "react";
import styled from "styled-components";

const Container = styled.div`
  height: 14.979px;
  width: 14.558px;

  margin: auto;

  @media (min-width: 1800px) {
    height: 19.87px;
    width: 19.31px;
  }

  @media (max-width: 575px) {
    height: 15px;
    width: 14.58px;
  }
`;

const SendIcon = () => {
  return (
    <Container>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 14.558 14.979"
      >
        <path
          id="Path_21546"
          data-name="Path 21546"
          d="M233.624,413.589l-12.895,6.655a.834.834,0,0,0,0,1.48l12.895,6.659a.831.831,0,0,0,1.135-1.085l-2.01-4.425a.842.842,0,0,0-.63-.479L223,420.984l9.12-1.41a.842.842,0,0,0,.63-.48l2.01-4.425a.832.832,0,0,0-1.14-1.08Z"
          transform="translate(-220.279 -413.497)"
          fill="#fff"
        />
      </svg>
    </Container>
  );
};

export default SendIcon;
